import React, { useState, useCallback } from 'react';
import Button from '../bootstrap/Button';

const CodeSandboxEmbed = ({ src }) => {

    const [enableView, setEnableView] = useState(false)

    // The docs page is served cross-origin isolated (COOP/COEP) so embedded
    // StackBlitz WebContainer demos can use SharedArrayBuffer. Under COEP a
    // cross-origin iframe whose response lacks its own COEP header (StackBlitz
    // sends CORP but not COEP) is blocked — "stackblitz.com refused to connect".
    // The `credentialless` attribute lifts that embedding rule, but it only
    // takes effect if it is present BEFORE the frame's src navigates. React
    // sets `src` as a prop before ref callbacks run, so we build the iframe
    // imperatively here: set `credentialless` first, then `src` last.
    // Chromium-only; other browsers ignore the attribute (no regression).
    const mountIframe = useCallback((container) => {
        if (!container) return;
        container.innerHTML = '';
        const iframe = document.createElement('iframe');
        iframe.setAttribute('credentialless', '');
        iframe.title = 'CodeSandbox Embed';
        // `cross-origin-isolated` delegates the isolation permission to the
        // frame so the StackBlitz WebContainer (served with corp=1) can use
        // SharedArrayBuffer. Without it the frame stays un-isolated.
        iframe.allow = 'cross-origin-isolated; accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking';
        iframe.setAttribute('sandbox', 'allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts');
        iframe.style.cssText = 'width:100%;height:80vh;border:0;border-radius:4px;overflow:hidden;';
        iframe.src = src; // set last, after credentialless, so the initial navigation is credentialless
        container.appendChild(iframe);
    }, [src])

    return (
        <>
            {
                (!enableView) && <div>
                    <Button
                        color='info'
                        size='lg'
                        onClick={() => setEnableView(!enableView)}
                    >
                        {enableView ? 'Hide' : 'Show'} CodeSandbox
                    </Button>
                </div>
            }
            {
                enableView &&
                <>
                    <div className='text-danger'>Sandbox loading/rendering may take over 30 seconds...</div>
                    <div ref={mountIframe} style={{ width: '100%' }} />
                </>
            }
        </>
    );
};

export default CodeSandboxEmbed;
